import $ from 'jquery';

const togglePlayPause = (e, video, control) => {
    $(control).toggleClass('is-active');

    // play / pause video
    if (video[0].paused === false) {
        video[0].pause();
    } else {
        video[0].play();
    }

    // set aria
    if ($(e.currentTarget).hasClass('c-media-video-pause')) {
        $(e.currentTarget).attr('aria-hidden', true);
        $(e.currentTarget).prev().attr('aria-hidden', false);

    } else {
        $(e.currentTarget).attr('aria-hidden', true);
        $(e.currentTarget).next().attr('aria-hidden', false);
    }
};

function init({ selector = '.js-video'} = {}) {
    if (!selector){
        return;
    }

    $(selector).each(function() {
        const videoElement = $(this).find('video');
        const videoControl = $(this).find('.js-video-control');

        // bind events
        $(videoControl).on('click', (e) => {
            togglePlayPause(e, videoElement, videoControl);
        });
    });
}

export default {
    init
};
